<template>
  <b-card body-class="p-1">
    <div class="d-flex justify-content-between">
      <div class="text-left">
        <h2 :style="{ color: blobColor }">
          {{ value.toLocaleString() }}
        </h2>
        <small class="card-font">{{ label }}</small>
        <div
          v-if="showSub"
          class="d-flex"
        >
          <div
            class="sub-value d-flex align-items-center justify-content-center mr-1"
            :style="{ backgroundColor: iconBackgroundColor, cursor: 'pointer' }"
            @click="$emit('click-new')"
          >
            <div
              class="sub-icon"
              :style="{ backgroundColor: blobColor }"
            />
            New : {{ valueNew.toLocaleString() }}
          </div>
          <div
            class="sub-value d-flex align-items-center justify-content-center"
            :style="{ backgroundColor: '#D3D3D3' }"
          >
            <div
              class="sub-icon"
              :style="{ backgroundColor: '#636363' }"
            />
            Old : {{ valueOld.toLocaleString() }}
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center icon-col">
        <div
          class="icon-container d-flex align-items-center justify-content-center p-1"
          :style="{ backgroundColor: iconBackgroundColor }"
        >
          <img :src="tileIcon">
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },
  props: {
    value: { type: Number, required: true },
    valueNew: { type: Number, default: 0 },
    valueOld: { type: Number, default: 0 },
    showSub: { type: Boolean, default: false },
    label: { type: String, required: true },
    blobColor: { type: String, default: '#00BBFF' },
    tileIcon: { type: String, default: '' },
  },
  computed: {
    arrowRotation() {
      return {
        pending: 'rotate(180deg)',
        in: 'rotate(225deg)',
        out: 'rotate(90deg)',
      }[this.arrowDirection] || 'rotate(0deg)'
    },
    iconBackgroundColor() {
      const hex = this.blobColor.replace('#', '')

      // Parse R, G, B from hex
      const r = parseInt(hex.substring(0, 2), 16)
      const g = parseInt(hex.substring(2, 4), 16)
      const b = parseInt(hex.substring(4, 6), 16)

      return `rgba(${r}, ${g}, ${b}, 0.2)` // 20% opacity
    },
  },
}
</script>

<style>
.card-font {
    font-weight: 700;
    font-size: 1rem;
}
.icon-col {
  padding: 0.25rem;
}
.icon-container {
  background-color: aliceblue;
  border-radius: 12px;
}
.sub-value {
  padding: 5px;
  border-radius: 5px;
  margin-top: 5px;
}
.sub-value:hover {
  filter: brightness(0.9);
  transition: 0.2s;
}
.sub-icon {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  margin-right: 5px;
}
</style>
